<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="관리부서"
            name="deptCd"
            :isFirstValue="false"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-select
            :editable="editable"
            :comboItems="useFlagItems"
            label="사용여부"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            type="search"
            v-model="searchParam.useFlag">
          </c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="방지시설 목록"
          tableId="table"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="신규" icon="add" @btnClicked="detailPopup" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
export default {
  name: 'water-master-01',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
      }),
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: '',
        deptCd: '',
        title: '',
        useFlag: 'Y',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '80%',
        top: '',
        param: {},
        closeCallback: null,
      },
      editable: true,
      grid: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '사업장',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '방지시설명',
            align: 'center',
            type: 'link',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '방지시설 관리번호',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'col30',
            field: 'col30',
            label: '처리용량(㎥/분)',
            align: 'right',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'col31',
            field: 'col31',
            label: '설계(허가증)용량(㎥/분)',
            align: 'right',
            style: 'width: 200px',
            sortable: true,
          },
          {
            name: 'col32',
            field: 'col32',
            label: '허가증 기준유량(%)',
            align: 'right',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '관리부서',
            align: 'center',
            sortable: true,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '사용여부',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
        ],
        data: [],
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          col0: '구지1공장',
          col1: 'G1A (저장~혼합)',
          col2: 'EQ-01-021',
          col3: '안전환경팀',
          col4: 'Y',
          col30: '300',
          col31: '181.61',
          col32: '61%',
        },
        {
          col0: '구지1공장',
          col1: 'G1C (저장~혼합)',
          col2: 'EQ-01-022',
          col3: '안전환경팀',
          col4: 'Y',
          col30: '300',
          col31: '137.59',
          col32: '46%',
        },
        {
          col0: '구지1공장',
          col1: 'G2A (저장~혼합)',
          col2: 'EQ-01-023',
          col3: '안전환경팀',
          col4: 'Y',
          col30: '300',
          col31: '185.62',
          col32: '62%',
        },
        {
          col0: '구지1공장',
          col1: 'G4B (혼합~충진)',
          col2: 'EQ-01-024',
          col3: '안전환경팀',
          col4: 'Y',
          col30: '300',
          col31: '181.61',
          col32: '61%',
        },
      ]
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./airMaster03Detail.vue"}`);
      this.popupOptions.title = '대기 방지시설 상세';
      this.popupOptions.param = {
        psiDocumentId: result,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
